/**
 *  0. Internationalization
 *  1. Suitcase and login functions
 *  2. Save Location Map Coordinates
 *  3. Modal creation
 *  4. Brochure drag-n-drop
 *  5. Brochure mouse over functions
 *  6. Rack Builder
 *  7. Brochure Class
 *  8. Brochure Details
 *  9. Location Manager Class
 * 10. Banner Pool Management Class
 * 11. Instantiate LocationManager (lm) and VTips.RackBuilder (rb)
 * 12. Bind onChangeDestination event to LocationManager (lm)
 * 13. Hot Deals functions
 * 14. loadBrochureData function
 * 15. initMapOnPoint function
 * 16. Panel class
 * 17. DestinationView class
 * 18. Rack repositioning timer
 * 19. Kiosk Timer
 * 20. Touch punch for enabling touch
 * 21. Category Filters
 * 22. Search
 * 23. Stats
 * 24. Utility
 **/
var brochureLoader = new Image();
var regionId = 0;
var totalSaved = 0;
var headerSelector = '#header-bar';
var rackSelector = '.rack,.rack-slider';
var rackRowSelector = '.rack-row';
var outerRackContainerSelector = '#ph_main';
var $loadingImage = null;

var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry)/);
/**
 * 0. Internationalization
 **/
// Changes must also be reflected in mobile Javascript js/mobilel/site.js
var i18n = {
	/**
	 * Get the international version of the requested URL and append the queryString
 	 */
	getUrl : function(url, queryStr) {
		if (i18n.languageCode.length > 0) url = '/' + i18n.languageCode + url;
		var firstChar = (url.indexOf('?') >= 0 ? '&': '?');
		if (queryStr && queryStr.length > 0) url += firstChar + queryStr;
		return url;
	},
	// A language code that can be prepended to a URL
	languageCode : '',
	lang : {
		default: {
			general : {
				unknownErrorTitle : 'Unknown Error',
				unknownErrorDescription : 'An unknown error occurred.  Please try again shortly.',
				loading : 'Loading...',
				submittingDotDotDot : 'Submitting...',
				backTo: 'Back to'
			},
			suitcase : {
				saveTitle : 'Save brochures for later?',
				saveDescription : 'Would you like to be able to save your brochures for long term access?',
				yourSuitcase : 'Your Suitcase'
			},
			account : {
				notRegisteredQuestion: 'Not registered?',
				registerHere: 'Register Here',
				clickHere: 'Click Here',
				emailPrompt: 'Email:',
				passwordPrompt: 'Password:',
				signInTitle: 'Sign In',
				registrationTitle: 'Register',
				alreadyRegisteredQuestion: 'Already registered?',
				signInHere: 'Sign In Here',
				confirmPasswordPrompt: 'Confirm Password:',
				postalCodePrompt: 'Zip/postal code:',
				missingEmailAndPassword: 'Please enter an email and a password',
				logOut: 'Log Out'
			},
			brochureDetail : {
				publicationDetail: 'Publication Detail'
			}
		},
		de: {
			general : {
				unknownErrorTitle : 'Unbekannter Fehler',
				unknownErrorDescription : 'Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es in Kürze wieder.',
				loading : 'Loading...',
				submittingDotDotDot : 'Einreichen...',
				backTo: 'Zurück'
			},
			suitcase : {
				yourSuitcase : 'Broschüren' //
			},
			account : {
				notRegisteredQuestion: 'Nicht registriert?',
				registerHere: 'Hier registrieren',
				clickHere: 'Click Here',
				emailPrompt: 'Email:',
				passwordPrompt: 'Passwort:',
				signInTitle: 'Anmelden',
				registrationTitle: 'Neu registrieren',
				alreadyRegisteredQuestion: 'Bereits registriert?',
				signInHere: 'Hier anmelden',
				confirmPasswordPrompt: 'Passwort bestätigen:',
				postalCodePrompt: 'Postleitzahl:',
				missingEmailAndPassword: 'Bitte geben Sie eine E-Mail und Passwort.',
				logOut: 'Abmelden'
			},
			brochureDetail : {
				publicationDetail: 'Broschüre Informationen'
			}
		},
		es: {
			general : {
				unknownErrorTitle : 'Error desconocido',
				unknownErrorDescription : 'Un error desconocido ocurrió. Por favor , inténtelo de nuevo en breve.',
				loading : 'Cargando...',
				submittingDotDotDot : 'Enviando...',
				backTo: 'Atrás'
			},
			suitcase : {
				yourSuitcase : 'Folletos Almacenados' // Stored brochures
			},
			account : {
				notRegisteredQuestion: '¿No registrado?',
				registerHere: 'Registrar aquí',
				clickHere: 'Clickea aquí',
				emailPrompt: 'Email:',
				passwordPrompt: 'Clave:',
				signInTitle: 'Ingresar',
				registrationTitle: 'Registro',
				alreadyRegisteredQuestion: '¿Ya registrado?',
				signInHere: 'Firme aquí',
				confirmPasswordPrompt: 'Confirmar contraseña:',
				postalCodePrompt: 'Código Postal:',
				missingEmailAndPassword: 'Por favor, introduzca un correo electrónico y una contraseña.',
				logOut: 'Cerrar sesion'
			},
			brochureDetail : {
				publicationDetail: 'Información Folleto'
			}
		},
		fr: {
			general : {
				unknownErrorTitle : 'Erreur inconnue',
				unknownErrorDescription : 'Une erreur inconnue est survenue. S\'il vous plaît essayer à nouveau bientôt.',
				loading : 'Chargement...',
				submittingDotDotDot : 'Envoi en cours...',
				backTo: 'Arrière'
			},
			suitcase : {
				yourSuitcase : 'Brochures' // Brochures
			},
			account : {
				notRegisteredQuestion: 'Non enregistré?',
				registerHere: 'Inscrivez-vous ici',
				clickHere: 'Cliquez içi',
				emailPrompt: 'Email:',
				passwordPrompt: 'Mot de passe:',
				signInTitle: 'S\'inscrire',
				registrationTitle: 'Registre',
				alreadyRegisteredQuestion: 'Déjà enregistré?',
				signInHere: 'Se connecter ici',
				confirmPasswordPrompt: 'Confirmez le mot de passe:',
				postalCodePrompt: 'Code Postal:',
				missingEmailAndPassword: 'S\'il vous plaît entrer un email et un mot de passe.',
				logOut: 'Se déconnecter'
			},
			brochureDetail : {
				publicationDetail: 'Brochure d\'information'
			}
		},
		zh: {
			general : {
				unknownErrorTitle : '未知錯誤',
				unknownErrorDescription : '出現未知錯誤。請稍後再試。',
				loading : '載入中...',
				submittingDotDotDot : '提交...',
				backTo: '背部'
			},
			suitcase : {
				yourSuitcase : '小冊子' // brochures
			},
			account : {
				notRegisteredQuestion: '還沒註冊？',
				registerHere: '在這裡註冊',
				clickHere: '點擊這裡',
				emailPrompt: '電子郵件：',
				passwordPrompt: '密碼：',
				signInTitle: '登陸',
				registrationTitle: '註冊',
				alreadyRegisteredQuestion: '已經註冊？',
				signInHere: '在此登錄',
				confirmPasswordPrompt: '確認密碼：',
				postalCodePrompt: '郵政編碼：',
				missingEmailAndPassword: '請輸入電子郵件和密碼。',
				logOut: '登出'
			},
			brochureDetail : {
				publicationDetail: '宣傳冊資料'
			}
		}
	},
	translate : function(domain, key) {
		var defaultLangCode = 'default';
		var languageCode = (i18n.languageCode.length>0) ? i18n.languageCode : defaultLangCode;
		var txt = '';
		if (typeof(i18n.lang[languageCode]) != 'undefined') {
			// Primary translation
			if (typeof(i18n.lang[languageCode][domain]) != 'undefined' && typeof(i18n.lang[languageCode][domain][key]) != 'undefined') {
				txt = i18n.lang[languageCode][domain][key];
			// Default translation
			} else if (typeof(i18n.lang[defaultLangCode][domain]) != 'undefined' && typeof(i18n.lang[defaultLangCode][domain][key]) != 'undefined') {
				txt = i18n.lang[defaultLangCode][domain][key];
			} else {
				console.log('Missing translation: ' + domain + '.' + key);
			}

		}
		return txt;
	},
	suitcase : {
		url : '/suitcase/',
		popupUrl: '/suitcase/handlepopup.html',
		getUrl : function(queryStr) { return i18n.getUrl(i18n.suitcase.url, queryStr); },
		getPopupUrl: function(queryStr) { return i18n.getUrl(i18n.suitcase.popupUrl, queryStr); }
	}
}

/**
 * 1. Suitcase and login functions
 **/
// Quick notification
function flashNotification(txt, timeout) {
    if (!timeout) timeout = 1000;

    var $notification = $('<div />')
        .css({
            backgroundColor: '#e7ecf2',
            boxShadow: '0 0 10px #ccc',
            borderRadius: 5,
            color: '#000',
            position: 'fixed',
            left: 0,
            padding: 20,
            top: 0,
            visibility: 'hidden'
        })
        .text(txt)
        .appendTo($('body'));
    $notification.css({
        left: ($(window).width() / 2) - ($notification.outerWidth() / 2),
        top: ($(window).height() / 2) - ($notification.outerHeight() / 2),
        visibility: 'visible'
    });

    setTimeout(function() {
        $notification.fadeOut('fast', function() {
            $notification.remove();
        });
    }, timeout);
}

function setSuitcaseStatus(status) {
	$('#suitcase-label-status').html(status);
}

function setLoggedInStatus(is_logged_in, username) {
	var status;
	if (is_logged_in) {
		if (username.length > 20) username = username.substr(0, 17) + '...';
		status = username + '<br />';
		status += '<a href="#" onclick="signOut();return false;">' + i18n.translate('account', 'logOut') + '</a>';
	} else {
		status = '<a href="#" onclick="showSignInPopup();return false;">' + i18n.translate('account', 'signInTitle') + '</a>';
		status += '<a href="#" onclick="showRegisterPopup();return false;">' + i18n.translate('account', 'registrationTitle') + '</a>';
	}
	$('#loggedin-label-status').html(status);
}

function removeBrochureFromSuitcase(brochure) {
	jQuery.ajax({
		url:i18n.suitcase.getUrl('mode=ajax&removelisting='+brochure),
		dataType:'json',
		success:function(data) {
			valid = false;
			if (data.response) {
				if (data.response.status) {
					if (data.response.status == 'success') {
						doit({"event":"Unsave Brochure"});
						//callback.call(this, data);
					}
				}
			}

			if (valid) {
				//delegate.html('saved');
			} else {
				//delegate.html('try again...');
			}
			totalSaved = data.response.numListings;
			setSuitcaseStatus('Removing...');
			resetSuitcase();
		}
	});
}
function removeAllBrochuresFromSuitcase() {
	jQuery.ajax({
		url:i18n.suitcase.getUrl('mode=ajax&removealllistings=true'),
		dataType:'json',
		success:function(data) {
			valid = false;
			if (data.response) {
				if (data.response.status) {
					if (data.response.status == 'success') {
						doit({"event":"Unsave All Brochures"});
						//callback.call(this, data);
					}
				}
			}

			totalSaved = data.response.numListings;
			setSuitcaseStatus('Deleted...');
			resetSuitcase();
		}
	});
}

/**
 * Save a brochure to the suitcase and call callback if defined
 * @param brochure
 * @param callback
 */
function saveBrochureToSuitcase(brochure, source, callback) {
	saveItemToSuitcase('listing', brochure, null, source, callback);
}
function saveItemToSuitcase(itemType, itemId, locationId, source, callback) {
    if (!source) source = 'Unknown';
    if (!callback || (callback && typeof(callback) != 'function')) callback = function() {};
	var locationParam = typeof(locationId) != 'undefined' ? '&locationid='+locationId : '';
    jQuery.ajax({
        url:i18n.suitcase.getUrl('ajax=true&sit=' + itemType + '&additem='+itemId + locationParam),
        dataType:'json',
        success:function(data) {
			if (data.response.status) {
				if (data.response.status == 'success') {
					doit({"action":"Save Item ("+itemType+")","savedFrom":source});
					callback.call(this, data);
				}
			}

            totalSaved = data.response.numListings;
            setSuitcaseStatus(data.response.txtSaved);
            resetSuitcase();
        }
    });
}

function askToSaveItemsForLater(saveTitle, saveDescription) {
	if (!saveTitle) saveTitle = i18n.translate('suitcase', 'saveTitle');
	if (!saveDescription) saveDescription = i18n.translate('suitcase', 'saveDescription');
	var modalBody = saveDescription +
		'<div class="save-for-later-btn-row">' +
		'<a href="#" onclick="showRegisterPopup();return false;" class="save-yes"></a> ' +
		'<a href="#" onclick="VTips.WM.getModalManager().close();return false;" class="save-no"></a>' +
		'</div>';
	var modalBox = createVTipsModalBox(saveTitle, modalBody);
	var wndw = VTips.WM.Window.createWindowWithContent('saving-suitcase', 350, 300, modalBox);
	VTips.WM.getModalManager().pushWindow( wndw, {allowClickOutside:true} );
}

/**
 * @param int brochure
 * @param string source The name of the source that initiated the save
 **/
function addBrochureToSuitcase(brochure, source) {
    saveBrochureToSuitcase(brochure, source, function(data) {
        if (!data.response.signedIn) {
            askToSaveItemsForLater(data.response.saveTitle, data.response.saveDescription);
        }
    });
}
function addItemToSuitcase(itemType, itemId, locationId, source, callback) {
	saveItemToSuitcase(itemType, itemId, locationId, source, function(data) {
	    // if (shouldPromptSignin) {
         //    if (!data.response.signedIn) {
         //        askToSaveItemsForLater(data.response.saveTitle, data.response.saveDescription);
         //    }
        // } else {
	        flashNotification('Saved');
        // }
        if (data.response.status) {
            if (data.response.status == 'success') {
                doit({"action":"Save Item ("+itemType+")","savedFrom":source});
                callback.call(this, data);
            }
        }

    });
}

/**
 * @param int brochure
 * @param callback
 **/
function toggleBrochureSaved(brochure, saveSource, callback) {
    if (!saveSource) saveSource = 'Unknown';
    if (!callback || (callback && typeof(callback) != 'function')) callback = function() {};
    jQuery.ajax({
        url:i18n.suitcase.getUrl('ajax=true&togglelisting='+brochure),
        dataType:'json',
        error:function(data) {},
        success:function(data) {
            valid = false;
            if (data.response) {
                if (data.response.status && data.response.status == 'success') {
                    totalSaved = data.response.numListings;
                    setSuitcaseStatus('Saved...');
                    resetSuitcase();

					doit({"event":data.response.isInCart?"Save Brochure":"Unsave Brochure", "savedFrom" : saveSource});
					callback.call(this, data);
                }
            }
        }
    });
}

function toggleItemSaved(itemType, itemId, locationId, saveSource, callback) {
    if (!saveSource) saveSource = 'Unknown';
    if (!callback || (callback && typeof(callback) != 'function')) callback = function() {};
    var locationIdParam = typeof(locationId) != 'undefined' ? '&locationid='+locationId : '';
    jQuery.ajax({
        url:i18n.suitcase.getUrl('ajax=true&sit='+itemType+'&toggleitem='+itemId + locationIdParam),
        dataType:'json',
        error:function(data) {},
        success:function(data) {
            valid = false;
			if (data.response.status && data.response.status == 'success') {
                totalSaved = data.response.numItems;
                setSuitcaseStatus('Saved...');
                resetSuitcase();

				doit({"event":data.response.isInCart?"Save Item ("+itemType+")":"Unsave Item ("+itemType+")", "savedFrom" : saveSource});
				callback.call(this, data);
			}
        }
    });
}

function detailToggleBrochureSaved(brochure, linkObj) {

	var suitcaseClass = 'in-suitcase';

	// Real-time feedback
	$(linkObj).toggleClass(suitcaseClass);

	toggleBrochureSaved(brochure, "Brochure Detail", function(data) {

		if (data.response.isInCart) {

			// Kiosk: $(linkObj).text('IN SUITCASE');
			// Make sure linkObj has correct class
			if (!$(linkObj).hasClass(suitcaseClass)) $(linkObj).addClass(suitcaseClass);

			if (rb.viewingSuitcase) {
				rb.suitcaseChanged = true;
			} else {
				if (!data.response.signedIn) {
					rb.closeBrochureView();

					askToSaveItemsForLater(data.response.saveTitle, data.response.saveDescription);
				}
			}
		} else {

			if (rb.viewingSuitcase) { // Suitcase screen is loaded, so remove from suitcase screen in real-time
				$('#suitcaselisting'+brochure).remove()
			}

			// Make sure linkObj has correct class
			$(linkObj).removeClass(suitcaseClass);
		}
	});
}

function resetSuitcase() {
	$('#suitcase-count').text(totalSaved);

	if (parent.document !== document) { // Prevent infinite loop
        parent.totalSaved = totalSaved;
        parent.resetSuitcase();
	}
}

function handleRegisterSignIn(frm) {
	var data = {};
	for(i=0; i < frm.elements.length; i++) {
		data[frm.elements[i].name] = frm.elements[i].value;
	}

	jQuery.ajax({
		url : i18n.suitcase.getPopupUrl(),
		data : data,
		dataType : 'json',
		success : function(data) {
			if (data.response.valid) {
				setLoggedInStatus(true, data.response.username);

				if (data.response.callback) {
					data.response.callback();
				}
				var success = createVTipsModalBox(data.response.successTitle, data.response.successDescription + ' <a href="#" onclick="VTips.WM.getModalManager().close();return false;">' + data.response.txtClose + '</a>');
				VTips.WM.getModalManager().pushWindow( VTips.WM.Window.createWindowWithContent('register-success', 300, 200, success) );

				if (data.response.numListings) {
					totalSaved = data.response.numListings;
					resetSuitcase()
				}

				if (data.doit) doit(data.doit);
			} else {
				$(frm).children('.popupwindowerror').html(data.response.error).fadeIn();
			}
		}
	});
}

function signOut() {

	jQuery.ajax({
		url : i18n.suitcase.getPopupUrl('action=logout'),
		dataType : 'json',
		success : function(data) {

			VTips.WM.getModalManager().close();

			var responseWindow;

			if (data.response.valid) {
				responseWindow = createVTipsModalBox(data.response.title, data.response.message);
				setLoggedInStatus(false);
				if (data.response.numListings) {
					totalSaved = data.response.numListings;
				} else {
					totalSaved = 0;
				}
				resetSuitcase();
			} else {
				responseWindow = createVTipsModalBox(
					i18n.translate('general', 'unknownErrorTitle'),
					i18n.translate('general', 'unknownErrorDescription')
				);
			}
			VTips.WM.getModalManager().pushWindow( VTips.WM.Window.createWindowWithContent('register-success', 300, 200, responseWindow) );
			if (data.doit) doit(data.doit);
		}
	});
}

function showSignInPopup() {
	var modalBody = '<form method="post" onsubmit="handleRegisterSignIn(this);return false;" class="form">' +
		'<div class="popupwindowerror"></div>' +
		'<input type="hidden" name="action" value="signin" />' + i18n.translate('account', 'notRegisteredQuestion') + '  ' +
		'<a href="#" onclick="showRegisterPopup();false;">' + i18n.translate('account', 'registerHere') + '</a><br />' +
		'Forgot your password?  <a href="/forgotpassword.html">' + i18n.translate('account', 'clickHere') + '</a>' +
		'<table cellspacing="0" cellpadding="5" border="0"><tr><td>' + i18n.translate('account', 'emailPrompt') + '</td><td><input type="text" name="email" size="30" class="input" /></td></tr><td>' + i18n.translate('account', 'passwordPrompt') + '</td><td><input type="password" name="password" size="10" class="input" /></td></tr></table>' +
		'<a href="#" onclick="$(this).parents(\'form\').submit();return false;" class="btn-signin"></a>'+
		'</form>';
	var modalBox = createVTipsModalBox(i18n.translate('account', 'signInTitle'), modalBody);
	var wndw = VTips.WM.Window.createWindowWithContent('saving-suitcase', 350, 300, modalBox);
	VTips.WM.getModalManager().pushWindow( wndw, {allowClickOutside:true} );

	windowIndex = VTips.WM.getModalManager().getCurrentWindowIndex();
	if (windowIndex > 0) VTips.WM.getModalManager().removeWindowAtIndex(windowIndex-1); // Remove underneath window
}

function showRegisterPopup() {
	var modalBody = '<form method="post" onsubmit="handleRegisterSignIn(this);return false;" class="form">' +
		'<div class="popupwindowerror"></div>' +
		'<input type="hidden" name="action" value="register" />' + i18n.translate('account', 'alreadyRegisteredQuestion') + '  ' +
		'<a href="#" onclick="showSignInPopup();false;">' + i18n.translate('account', 'signInHere') + '</a>' +
		'<table cellspacing="0" cellpadding="5" border="0"><tr><td>' + i18n.translate('account', 'emailPrompt') + ' </td><td><input type="text" name="email" size="30" class="input" /></td></tr><tr><td>' + i18n.translate('account', 'passwordPrompt') + '</td><td><input type="password" name="password" size="10" class="input" /></td></tr><tr><td>' + i18n.translate('account', 'confirmPasswordPrompt') + '</td><td><input type="password" name="confpassword" size="10" class="input" /></td></tr><tr><td>' + i18n.translate('account', 'postalCodePrompt') + '</td><td><input type="text" name="postal" size="10" class="input" /></td></tr></table>' +
		'<a href="#" onclick="$(this).parents(\'form\').submit();return false;" class="btn-register"></a>' +
		'</form>';
	var modalBox = createVTipsModalBox( i18n.translate('account', 'registrationTitle') , modalBody);
	var wndw = VTips.WM.Window.createWindowWithContent('saving-suitcase', 350, 300, modalBox);
	VTips.WM.getModalManager().pushWindow( wndw, {allowClickOutside:true} );

	windowIndex = VTips.WM.getModalManager().getCurrentWindowIndex();
	if (windowIndex > 0) VTips.WM.getModalManager().removeWindowAtIndex(windowIndex-1); // Remove underneath window
}

function closeSuitcase() {
	dview.getPanel('left-bar').show();

	rb.viewingSuitcase = false;
	var loadedSuitcase;
	if (loadedSuitcase = document.getElementById('loaded-suitcase')) {
		$(loadedSuitcase).remove();
	}

}

function loadSuitcase(loadFromDesc) {

	var alreadyViewingSuitcase = rb.viewingSuitcase;

	rb.viewingSuitcase = true;

	VTips.WM.getModalManager().pushWindow( VTips.WM.Window.createWindowWithContent('loading-brochure', null, null, i18n.translate('general', 'loading') + '<br /><span style="font-size:2em;">' + i18n.translate('suitcase', 'yourSuitcase') + '</span>') );

	jQuery.get( i18n.suitcase.getUrl('ajax=true'), function(data) {
		VTips.WM.getModalManager().close();

		if (data.length > 0) {
			dview.getPanel('left-bar').hide();
			var suitcase = '' +
				'<div id="loaded-suitcase">' +
					'<div id="loaded-suitcase-btns-wrap">' +
						'<div align="right" id="loaded-suitcase-btns">' +
							'<a href="#" onclick="$(\'.suitcaselisting\').remove();removeAllBrochuresFromSuitcase();closeSuitcase();return false;" class="btn-removeall"></a>' +
							' | ' +
							'<a href="#" onclick="closeSuitcase();return false;" class="btn btn-backtorack">' + i18n.translate('general', 'backTo') + '<i class="btn-backtorack-arrow"></i><i class="btn-backtorack-grid"></i></a>' +
							' | ' +
							'<a href="#" onclick="window.open(\'' + i18n.suitcase.getUrl('mode=print') + '\', \'print-brochures\',\'width=900,height=600,resizable=1\');return false;"><img src="/assets/vtips/img/i_print.gif" width="16" height="16" border="0" align="top" style="margin-top:10px;" /></a>' +
						'</div>' +
					'</div>' +
					'<div id="loaded-suitcase-brochures-wrap">' +
						'<div id="loaded-suitcase-brochures">' + data + '</div>' +
					'</div>' +
				'</div>';
			$('body').append( $(suitcase) );
		} else {
			var modalBox = createVTipsModalBox('Suitcase', '<div style="text-align:center;height: 160px;"><img src="/assets/vtips/img/tpl/suitcase.png" width="151" height="123" border="0" /><p>0 Items(s).</p></div>');
			var wndw = VTips.WM.Window.createWindowWithContent('no-suitcase-items', 350, 200, modalBox);
			VTips.WM.getModalManager().pushWindow( wndw, {allowClickOutside:true} );
			//windowIndex = VTips.WM.getModalManager().getCurrentWindowIndex();
			//if (windowIndex > 0) VTips.WM.getModalManager().removeWindowAtIndex(windowIndex-1); // Remove underneath window
		}
		doit({"event":"View Suitcase", "loadedFrom":loadFromDesc});
	});

}

/**
 * 2. Save Location Map Coordinates
 **/
function saveLocationMapCoordinates(url, locationId, zoom, lat, lng) {
	data = {
		"url" : url,
		"locationid" : locationId,
		"zoom" : zoom,
		"lat" : lat,
		"lng" : lng
	};

	jQuery.ajax({
		url : url,
		data : data,
		dataType : 'json',
		success : function(data) {
			if (data.success) {
				alert('Map updated');
			} else {
				alert('Unable to update map due to an unknown error');
			}
		},
		error : function() {
			alert('Unable to update map due to a server error');
		}
	});
}

/**
 * 3. Modal creation
 **/
function createVTipsModalBox(title, content, optClose) {
	var output = '';
	if (typeof(optClose) == 'undefined') optClose = true;

	output += '<div class="popupwindow">';
		output += '<div class="popupwindow-top"><b><em>&nbsp;</em></b></div>';
		output += '<div class="popupwindow-main">';
			output += '<div class="dest-sel-h">';
				output += '<table cellspacing="0" cellpadding="0" border="0" width="100%"><tr>';
					output += '<td><span class="popupwindow-title">' + title + '</span></td>';
					output += '<td align="right">';
					if (optClose) {
						output += '<a href="#" onclick="VTips.WM.getModalManager().close();return false;" style="color:#990000;"><img src="/assets/vtips/img/window/b_x.gif" width="25" height="25" border="0" /></a>';
					} else {
						output += '&nbsp;';
					}
					output += '</td>';
				output += '</tr></table>';
			output += '</div>';
			output += '<div class="dest-sel-b">' + content.replace("'", "\'") + '</div>';
		output += '</div>';
		output += '<div class="popupwindow-bottom"><b><em>&nbsp;</em></b></div>';
	output += '</div>';

	return output;
}

/**
 * 4. Brochure drag-n-drop
 **/
var draggingBrochure = null;
$(document).ready(function(){

	$('#suitcase').droppable({
		accept:'.rack-pocket',
		_tolerance:'pointer',
		tolerance:'touch',
		over: function (event, ui) {
			$(this).addClass('suitcase-over');
		},
		out:function(event, ui) {
			$(this).removeClass('suitcase-over');
			resetSuitcase();
		},
		drop:function(event, ui) {
			//totalSaved++;
			$(this).removeClass('suitcase-over');
			brochure = rb.getWorkingBrochure();

			delegate = $(this);
			var txtSaving = $(this).attr('data-txt-saving');
			setSuitcaseStatus(txtSaving);

			addBrochureToSuitcase(brochure, "Drag-n-Drop");
		}

	});
});

/**
 * 5. Brochure mouse over functions
 **/
var currentHoverObject = null;
var hoverObjectTimer = null;
var isDragging = false;

function getHoverObject(obj_id) {
	if (!currentHoverObject) {
		currentHoverObject = $('<div></div>').attr('id', 'hoverdetail').css({position:'absolute', display:'none', zIndex:103});
		currentHoverObject.appendTo($('body'));
	}

	return currentHoverObject;
}
/*
function getBrochureLeft(obj) {
	return obj.offset().left + obj.width() + 15;
}
*/
function correctBrochureTop(top) {
	var usable_window_height = $(window).height() - 150;
	var brochure_height = 100;
	var lowest_top = usable_window_height - brochure_height;
	if (top > lowest_top) top = lowest_top;
	return top;
}

/**
 * 6. Rack Builder
 **/
VTips.RackBuilder = function() {
	this.resetPages();
	this.workingBrochure = null;
	this.viewingSuitcase = false; // Whether the suitcase is currently being viewed
	this.suitcaseChanged = false; // If viewingCase, track whether items were added or removed
	this.loadedBrochureWindow = null;
	this.brochureDetailView = null;
	this._autoResizeBrochureHeight = true;
}
VTips.RackBuilder.prototype.resetPages = function() {
	this.curPageIndex = null;
	this.pages = [];
}
VTips.RackBuilder.prototype.addPage = function(page_id) {
	this.pages.push(page_id);
}
VTips.RackBuilder.prototype.getWorkingBrochure = function() { return this.workingBrochure; }
VTips.RackBuilder.prototype.getTotalPages = function() { return this.pages.length; }
VTips.RackBuilder.prototype.hasPages = function() { return (this.getTotalPages() > 0); }
VTips.RackBuilder.prototype.setWorkingBrochure = function(vtips_brochure) { this.workingBrochure = vtips_brochure; }
VTips.RackBuilder.prototype.getPageAtIndex = function(index) {
	if (this.pages[index]) return this.pages[index];
	else return false;
}
VTips.RackBuilder.prototype.getCurrentPageIndex = function() { return this.curPageIndex; }
VTips.RackBuilder.prototype.setCurrentPageIndex = function(current_page_id) { return this.curPageIndex = current_page_id; }
VTips.RackBuilder.prototype.getPrevPageIndex = function() {
	if (this.getTotalPages() > 0) {
		var cur_page_index = this.getCurrentPageIndex();

		if (!cur_page_index && cur_page_index != 0) cur_page_index = 0;
		else cur_page_index = cur_page_index-1;

		if (cur_page_index < 0) cur_page_index = this.getTotalPages()-1;

		return cur_page_index;
	} else {
		return false;
	}

}
VTips.RackBuilder.prototype.getNextPageIndex = function() {
	if (this.getTotalPages() > 0) {
		var cur_page_index = this.getCurrentPageIndex();

		if (!cur_page_index && cur_page_index != 0) cur_page_index = 0;
		else cur_page_index = cur_page_index+1;

		if (cur_page_index > this.getTotalPages()-1) cur_page_index = 0;

		return cur_page_index;
	} else {
		return false;
	}

}
VTips.RackBuilder.prototype.repositionRack = function(animate) {

	var resource_bar_width = 138;
	var location_bar_width = 180;
	var min_broch_height = 50;
	var max_broch_height = 100;

	var header_height = $(headerSelector).height();

	var rack_width = $(rackSelector).width();
	var rack_height = $(rackSelector).height();

	var outer_container = $(outerRackContainerSelector);
	var outer_container_margin = parseInt(outer_container.css('margin-top'));
	var rack_rows = $(rackRowSelector);
	var wasted_vertical = rack_height - (rack_rows.height()*rack_rows.length) + outer_container_margin; // Amount of space, excluding brochure row height, being wasted on graphics and spacing

	var screen_height = $(window).height();
	var screen_width = $(window).width();

	var realestate_width = screen_width - location_bar_width - resource_bar_width;
	var realestate_height = screen_height - header_height;

	var new_row_height = Math.floor( (realestate_height - wasted_vertical) / rack_rows.length);
	if (new_row_height > max_broch_height) new_row_height = max_broch_height;
	else if (new_row_height < min_broch_height) new_row_height = min_broch_height;

	if (new_row_height != rack_rows.height) {
		if (this.shouldAutoResizeBrochureHeight()) $(rackRowSelector).height(new_row_height);
		rack_height = $(rackSelector).height();
	}

}

VTips.RackBuilder.prototype.displayPage = function(goto_page_index) {

	if (this.hasPages()) {

		var cur_page_index = this.getCurrentPageIndex();
		var next_page_index = goto_page_index;//this.getNextPageIndex();

		if (next_page_index != cur_page_index) {

			this.setCurrentPageIndex(next_page_index);

			if (this.getPageAtIndex(cur_page_index)) { // Show next page
				$('#display-page-num').text(next_page_index+1);
				var delegate = this;
				var rack_page = jQuery('#' + this.getPageAtIndex(cur_page_index));
				/*rack_page.fadeOut(function() {
					jQuery('#' + delegate.getPageAtIndex(next_page_index)).fadeIn();
				});
				*/
				rack_page.animate({
						  height:'toggle'
						  }, 300, function() {
							  jQuery('#' + delegate.getPageAtIndex(next_page_index)).animate({
															 height:'toggle'
															 }, 500);
						  });
				this.repositionRack();
			} else { // Show first page

				var rack = jQuery('#' + this.getPageAtIndex(next_page_index));

				//$('#rack-pages').hide();
				//$(rackSelector).hide();
				$(rackSelector).hide();

				rack.show();
				this.repositionRack();
				//$('#rack-pages').show();
				$(rackSelector).show();
				//jQuery('#' + this.getPageAtIndex(next_page_index)).fadeIn();
			}

		}
	} // else no pages
}
/*
VTips.RackBuilder.prototype.loadDynamicPage = function(label, load_url) { // Page turner
	//var brochure_link = lm.getBaseLink() + '?ajax=1';

	VTips.WM.getModalManager().pushWindow( VTips.WM.Window.createWindowWithContent('loading-brochure', null, null, i18n.translate('general', 'loading') + '<br /><span style="font-size:2em;">' + label + '</span>') );

	//$('#destination-name span').text(data.location.getCityName());
	//document.title = 'Changed destination to ' + data.location.getCityName();

	//VTips.WM.getModalManager().pushWindow( VTips.WM.Window.createWindowWithContent('loading-brochure', null, null, i18n.translate('general', 'loading') + '<br /><span style="font-size:2em;">' + lm.getCityName() + '</span>') );
	jQuery.get(load_url, function(data) {
		VTips.WM.getModalManager().close();
		$('#ph_main').html(data);
	});
}
*/

VTips.RackBuilder.prototype.shouldAutoResizeBrochureHeight = function() {
	return this._autoResizeBrochureHeight;
}

VTips.RackBuilder.prototype.enableAutoResizeBrochureHeight = function() {
	this._autoResizeBrochureHeight = true;
}
VTips.RackBuilder.prototype.disableAutoResizeBrochureHeight = function() {
	this._autoResizeBrochureHeight = false;
}
VTips.RackBuilder.prototype.displayNextPage = function() {
	var next_page_index = this.getNextPageIndex();
	this.displayPage(next_page_index);
}
VTips.RackBuilder.prototype.displayPrevPage = function() {
	var prev_page_index = this.getPrevPageIndex();
	this.displayPage(prev_page_index);
}

VTips.RackBuilder.prototype.makeBrochuresDraggable = function() {

	// Dragging and mousing over brochures disabled
	if (isMobile) return;

	$('.rack-pocket').draggable({
		_helper:'clone',
		helper: function() {
			var $img = $(this).find('img');
			return $img.clone().appendTo($('body')).css({width:'100px',height:'auto',position:'absolute'});
		},
		start:function() {
			isDragging = true;
			if (currentHoverObject) currentHoverObject.hide();
			var obj_id = $(this).attr('data-brochure');

			if (obj_id) {
				//var brochure = VTips.Brochure.createFromBrochureObj(eval('brochdat'+obj_id));
				//rb.setWorkingBrochure(brochure);
				rb.setWorkingBrochure(obj_id);
			}
		},
		stop:function() {
			isDragging = false;
		},
		cursor:'move',
		cursorAt: {left:50, top:50 },
		appendTo:'body',
		/*refreshPositions:true*/
	});

	$('.rack-pocket').each(function() {
        var obj_id = $(this).attr('id').substr(11);
        // var hover_object = getHoverObject(obj_id);

		$(this)
			.mouseover(function(ev) {
				if (!isDragging) {

					var obj_id = $(this).attr('id').substr(11);

					var hover_object = getHoverObject(obj_id);

					hover_object.css({
						visibility: 'hidden',
						top:0,
						left:0
					});
					hover_object.show();

					var $img = $('#brochure-image-' + obj_id);

					var $hover = $('<div />').addClass('preview-brochure');
					var thumbnailSizeFactor = 1; // The number of times to increase the thumbnail (1.5 = increase by 50%)
					var $hoverImg = $('<img />').attr({src: $img.attr('src'), width: Math.floor($img.width()*thumbnailSizeFactor), border:0});
					var $hoverDragInfo = $('<div />').addClass('preview-brochure-instr').html('Drag to<br />Suitcase');

					$hover.append($hoverImg);
					$hover.append($hoverDragInfo);

					hover_object.empty().append($hover);

					setTimeout(function() {
						var hover_object_width = hover_object.width();
						var hover_object_height = hover_object.height();
						if (hover_object_height < 200) hover_object_height = 200; // In case height check fails for some reason, make sure object is somewhere above the mouse

						var left = $img.offset().left + $img.width() + 2;
						if (ev.pageX > ($(window).width()/2)) left = $img.offset().left - hover_object_width - 2;

						var top = $img.offset().top;

						var bottom = top + hover_object_height;
						var window_height = $(window).height();
						if (bottom > window_height) { // make sure thumbnail is on screen
							top -= (bottom - window_height);
						}

						// Move popup slightly up
						top -= 15;

						hover_object.css({ left:left,top:top,visibility:'visible'});//

						//hover_object.show('fast');
						if (hoverObjectTimer) {
							clearTimeout(hoverObjectTimer);
						}
					}, 10);
				}
			})
			.mouseout(function(ev) {
				if (!isDragging) {
					var obj_id = $(this).attr('id').substr(11);

					var hover_object = getHoverObject(obj_id);
					/*
					hoverObjectTimer = setTimeout(function() {
								if (currentHoverObject) {
									currentHoverObject.hide('fast');
								}
						}, 100);
					*/
					if (currentHoverObject) {
							currentHoverObject.hide();
						}
				}
			})
			.click(function(ev) {
				console.log('OBJ_ID: ', obj_id);
			});


	});
}

var hashBrochure = null;
var checkBackButtonCloseTimer = null;
var checkBackButtonCloseTimes = 0;

VTips.RackBuilder.prototype.detectBackButtonPressed = function() {
	//if (window.location.hash) {
		checkBackButtonCloseTimes ++;

		if (hashBrochure != window.location.hash) {
			this.closeBrochureView();
			return true;
		} else  if (checkBackButtonCloseTimes > 1000) {
			clearTimeout(checkBackButtonCloseTimer);
		}
        return false;
	/*} else {
		clearTimeout(checkBackButtonCloseTimer);
	}*/
}
VTips.RackBuilder.prototype.closeBrochureView = function() {
	jQuery(window).unbind('resize', this.handleWindowResize);

	if (rb.viewingSuitcase && rb.suitcaseChanged) {
		rb.suitcaseChanged = false;
	}

	if (this.loadedBrochureWindow) {
		this.loadedBrochureWindow.find('.brochure-detail-view').hide().appendTo($('body')); // Hide and move out of container to prevent it from being destroyed so that it can be reused
		this.loadedBrochureWindow.hide();
	}
	// Hide the currently loaded brochure
	if (this.brochureDetailView) this.brochureDetailView.hide();
	//$('#loaded-brochure-window').hide().find('.brochure-detail-view').hide();

	if (checkBackButtonCloseTimer) {
		clearTimeout(checkBackButtonCloseTimer);
		hashBrochure = null;
	}
	VTips.WM.getModalManager().close()

}

VTips.RackBuilder.prototype.resizeBrochureView = function() {
    var scrollTop = $(window).scrollTop();
    var overlayTop = 120;

    if (scrollTop >= 0 && scrollTop <= 120) overlayTop = overlayTop - scrollTop;
    else overlayTop = 0;

	var overlayObj = VTips.WM.getModalManager().getOverlayObj();
	overlayObj.css('width', jQuery(window).width());
	overlayObj.css('height', jQuery(window).width()-120);
	overlayObj.css('top', overlayTop);

	if (this.loadedBrochureWindow) {
		this.loadedBrochureWindow.css('width', jQuery(window).width()-180);
		this.loadedBrochureWindow.css('height', jQuery(window).height()-120);
	}
}
VTips.RackBuilder.prototype.handleWindowResize = function(ev) {
	ev.data.rb.resizeBrochureView.call(ev.data.rb);
}
var testing = false;
VTips.RackBuilder.prototype.openBrochureView = function(rack_brochure, locid, lat, lng, lsid) {
    this.clearKioskFields();

	var self = this;
	var alreadyLoaded = false;
	if (typeof(locid) === 'undefined') locid='';
	if (typeof(lsid) === 'undefined') lsid='';

	var getlink = '/search/detail.html?mode=ajax&listingid=' + rack_brochure + '&locid=' + locid + '&lsid=' + lsid + '&country=' + lm.getCountry() + '&state=' + lm.getState() + '&city=' + lm.getCityKey();

	if (lat && lng) {
		if (lat.length > 0 && lng.length > 0) {
			getlink += '&dc=' + lat + 'x'+lng; // destination coordinates
			var cityName = lm.getCityName();
			getlink += '&from=' + cityName;
		}
	}

    var scrollTop = $(window).scrollTop();
    var headerHeight = $('#header-bar').height();
    var overlayTop = headerHeight - scrollTop;
    if (overlayTop < 0) overlayTop = 0;

	var regionCss = {
		left:0,
		width: jQuery(window).width(),
		height: jQuery(window).height()-120,
		top: 120
	};

	if (!this.loadedBrochureWindow) {
		this.loadedBrochureWindow = $('<div></div>').attr('id', 'loaded-brochure-window');;
		$('body').append(this.loadedBrochureWindow);
	}
	this.loadedBrochureWindow.css(regionCss).css({
        width:regionCss.width - 180,
        paddingRight:180,
		position: 'absolute',
		zIndex: 200
		});

	/**
	 * See if the brochure is already loaded
	 */
	if (this.loadedBrochureWindow) {
        if (window.location.hash != '#disable-preload') {
            $existing = $('#broch-detail-' + rack_brochure);
            if ($existing.length > 0) {

                var overlay = VTips.WM.getModalManager().addOverlay(false);
                overlay.css(regionCss).css({
                    top: overlayTop,
                    height: overlay.height() + scrollTop
                });
                this.loadedBrochureWindow.append($existing);
                $existing.show();
                this.loadedBrochureWindow.show();
                jQuery(window).bind('resize scroll', {rb:this}, self.handleWindowResize);
                $(this).trigger('brochureOpened', {brochureId: rack_brochure});
                return;
            }
        }
	}

	var loading_window = VTips.WM.Window.createWindowWithContent('loading-brochure-detail', 400, 300, i18n.translate('general', 'loading') + '<br /><span style="font-size:2em;">' + i18n.translate('brochureDetail', 'publicationDetail') + '</span>');
	VTips.WM.getModalManager().pushWindow(loading_window);

	jQuery.get(getlink,

		function(data, status) {

			// Adjust overlay to fit window (less header and resource bar)
			var overlayObj = VTips.WM.getModalManager().getOverlayObj();

			overlayObj.css(regionCss);

			// Remove "Publication Detail" loading window
			VTips.WM.getModalManager().popWindow(false);

			// Adjust overlay as the window is resized
			jQuery(window).bind('resize scroll', {rb:self}, self.handleWindowResize);

			if (status=='success') {

				hashBrochure = '#brochix'+rack_brochure;
				window.location.href = hashBrochure;

				///////////////////////////////////////////

				var windowHeight = jQuery(window).height();

				self.loadedBrochureWindow.html(data).show();

				$(this).trigger('brochureOpened', {brochureId:rack_brochure});

				if (window.location.hash) {
					checkBackButtonCloseTimer = setInterval(function() { rb.detectBackButtonPressed() }, 1000);
				} // else has not supported

			} else {
				alert( i18n.translate('general', 'unknownErrorTitle') + ': ' + i18n.translate('general', 'unknownErrorDescription') );
			}
		}
	);
}
VTips.RackBuilder.prototype.clearKioskFields = function() {
	$('input[type=text].kiosk-clear').val('');
}

/**
 * 7. Brochure Class
 **/
VTips.Brochure = function() {
	this.id = null;
	this.displayName = null;
	this.addresses = [];
	this.mapAddress = {}
	this.emails = [];
	this.websites = [];
}

VTips.Brochure.prototype.getId = function() { return this.id; }
VTips.Brochure.prototype.getDisplayName = function() { return this.displayName; }

VTips.Brochure.prototype.setId = function(id) { this.id = id; }
VTips.Brochure.prototype.setDisplayName = function(display_name) { this.displayName = display_name; }


VTips.Brochure.createFromBrochureObj = function(broch_obj) {

	var brochure = new VTips.Brochure();
	brochure.setId(broch_obj.id[0]._data);
	brochure.setDisplayName(broch_obj.displayName[0]._data);

	if (broch_obj.addresses[0]) {
		addresses = broch_obj.addresses[0].address;
		if (addresses) {
			for(i=0; i < addresses.length; i++) {
				var address_string = '';
				var address = addresses[i];
				var map_address = '';
				if (address.street1) {
					address_string += address.street1[0]._data + '<br />';
					map_address += address.street1[0]._data;
				}
				if (address.street2) address_string += address.street2[0]._data + '<br />';
				if (address.street3) address_string += address.street3[0]._data + '<br />';
				if (address.city) {
					address_string += address.city[0]._data;
					map_address += ', ' + address.city[0]._data;
				}
				if (address.city && address.stateProvince) address_string += ', ';
				if (address.stateProvince) {
					address_string += address.stateProvince[0]._data;
					map_address += ', ' + address.stateProvince[0]._data;
				}
				if (address.city || address.stateProvince) address_string += '<br />';

				//brochure.addresses.push(
				brochure.addresses.push(address_string);
				if (i == 0) {
					brochure.mapAddress = map_address;
				}
				//alert('START: ' + brochure.addresses + ': END');
			}
		}
	}

	return brochure;
}

/**
 * 8. Brochure Details
 **/
function swapCovers(id) {
	if ($('#brochure-front-' + id).css('display') == 'block') {
		doit({"event":"Swap Brochure Cover", "coverSide":"Back"});
		$('#brochure-front-' + id).hide();
		$('#brochure-back-' + id).show();
	} else {
		doit({"event":"Swap Brochure Cover", "coverSide":"Front"});
		$('#brochure-back-' + id).hide();
		$('#brochure-front-' + id).show();
	}
}

function handleSelectBrochureDetailCover(domLink) {
	var $domLink = $(domLink);

	doit({"event":"Select Brochure Image", "ix": $domLink.attr('data-ix')});
	$domLink.parents('.brochure-image-thumbnails').find('.brochure-image-thumbnail').removeClass('selected'); // deselect other thumbnails
	$domLink.parent().addClass('selected'); // select current thumbnaijl
	var $brochureImages = $domLink.parents('.brochure-images').find('.brochure-image');
	$brochureImages.hide();
	$brochureImages.eq($domLink.attr('data-ix')).show();
}

function brochureDetailCheckWidth(brochure) {
	var windowWidth = $(window).width();
	var bodyWidth = $('body').width();
	var brochureDetailWidth = $('#broch-detail-'+brochure).width();

	//dview.getPanel('left-bar').hide();
	var leftBar = dview.getPanel('left-bar').getObj();
	var phMain = dview.getPanel('ph_main').getObj();
	var phMainMarginLeft = parseInt(phMain.css('margin-left'));
	/*if ((phMainMarginLeft - leftBar.width()) > 0) {
		phMain.css('margin-left', phMainMarginLeft - leftBar.width());
	}*/
	phMain.css('margin-left', 30);
	dview.getPanel('left-bar').hide();
	if (bodyWidth < brochureDetailWidth) $('body').width(brochureDetailWidth+'px');
}
function getBrochureOverlay() {
	var overlay = $('#brochure-view-overlay');
	if (overlay.length == 0) overlay = $('<div />').attr('id', 'brochure-view-overlay').prependTo($('body'));
	return overlay;
}
function adjustBrochureOverlay() {
	var overlay = getBrochureOverlay();

	var scrollTop = $(window).scrollTop();
	var overlayTop = 120;

	if (scrollTop >= 0 && scrollTop <= 120) overlayTop = overlayTop - scrollTop;
	else overlayTop = 0;

	overlay.css('top', overlayTop + 'px');

}
function brochurePageShare(brochurePageUrl, shareId, shareType, mode) {
	var $field = $('#' + shareId);
	var $shareBody = $field.parents('.share-body');
	var val = $field.val();

	if (val.length > 0) {

		var $sharingMessage = $('#sharing-message');
		if ($sharingMessage.length == 0) $sharingMessage = $('<p />').text('Sharing with ' + val + '...');
		$shareBody.before($sharingMessage.show());
		$shareBody.hide();


		var data = {
			action:'share',
			mode:mode,
		};
		data[shareType] = val;
		$.ajax({
			type:'post',
			url:brochurePageUrl,
			data:data,
			dataType:'json',
			success: function(data) {
				if (data.success) {
					$field.val('');
					$sharingMessage.text('Sent to ' + val);
					setTimeout(function() {
						$sharingMessage.remove();
						$shareBody.show();
					}, 3000);
				} else {
					$shareBody.show();
					$sharingMessage.remove();
					alert(data.message);
				}
			},
			error: function(data) {
				$shareBody.show();
				$sharingMessage.remove();
				alert('We apologize, but we experienced an error while trying to process your request');
			}
		});
	}
}
// Changes to handleContestRegistermust also be reflected in /assets/vtips/js/mobile/site.js
function handleContestRegisterSignIn(frm) {

	var data = {};
	for(i=0; i < frm.elements.length; i++) {
		var name = frm.elements[i].name;
		var value = frm.elements[i].value;
		if (name == 'officialrules') {
			if (frm.elements[i].checked) data[name] = value;
		} else {
			data[name] = value;
		}
	}
	var form_action = data.action;

	if (form_action != 'entercontests' && (data.email.length == 0 || data.password.length == 0)) {
		$(frm).children('.contestmessage').html( i18n.translate('account', 'missingEmailAndPassword') ).fadeIn();
	} else {
		$(frm).children('.contestmessage').html( i18n.translate('general', 'submittingDotDotDot') ).fadeIn();

		jQuery.ajax({
			url : i18n.suitcase.getPopupUrl(),
			data : data,
			dataType : 'json',
			success : function(data) {

				if (data.response.valid) {
					if (data.response.username) setLoggedInStatus(true, data.response.username);

					$(frm).children('.contestmessage').hide();

					if (data.response.numListings) {
						totalSaved = data.response.numListings;
						resetSuitcase()
					}

					$('#contest_anonymous').hide();

					if (data.response.contest_fields_required) {
						$('#contest_user_profile').show();
						$('#contest_user').hide();
					} else {
						$('#contest_user').show();
						$('#contest_user_profile').hide();
					}
					if (data.doit) doit(data.doitit);
				} else {
					$(frm).children('.contestmessage').html(data.response.error).fadeIn();
				}
			}
		});
	}
}
/**
 * 9. Location Manager Class
 **/
function LocationManager() {
	this.locationId = 0;
	this.country = '';
	this.state = '';
	this.cityKey = '';
	this.cityName = '';
	this.category = '';
	this.usingNearbyRegion = false; // Whether this is a city or nearby region
	this.currentView = '';
	// For testing only
	/*
	this.setCountry('usa');
	this.setState('ca');
	this.setCityKey('sandiego');
	this.setCityName('San Diego');
	*/
}

var sharedLocationManager;
LocationManager.sharedInstance = function() {
	if (!sharedLocationManager) sharedLocationManager = new LocationManager();
	return sharedLocationManager;
}
LocationManager.prototype.getLocationId = function() { return this.locationId; }
LocationManager.prototype.getCountry = function() { return this.country; }
LocationManager.prototype.getState = function() { return this.state; }
LocationManager.prototype.getCityKey = function() { return this.cityKey; }
LocationManager.prototype.getCityName = function() { return this.cityName; }
LocationManager.prototype.getCategory = function() { return this.category; }
LocationManager.prototype.getCurrentView = function() { return this.currentView; }

LocationManager.prototype.setLocationId = function(locationId) { this.locationId = locationId; }
LocationManager.prototype.setCountry = function(country) { this.country = country; }
LocationManager.prototype.setState = function(state) { this.state = state; }
LocationManager.prototype.setCityKey = function(city_key) { this.cityKey = city_key; }
LocationManager.prototype.setCityName= function(city_name) {
	this.cityName = city_name;
	city_obj = $('#destination-name span');
	city_obj.text(city_name)
	if (city_obj.height() > 20) {
		city_obj.css('marginTop', -6);
	} else {
		city_obj.css('marginTop', 0);
	}
}
LocationManager.prototype.setCategory = function(category) { this.category = category; }
LocationManager.prototype.setCurrentView = function(current_view) { this.currentView = current_view; }

LocationManager.prototype.openCitySelectionForStatePane = function(state_abbrev, state_name) {
	console.log('lm.openCitySelectionForStatePane: ' + $('#cities-for-'+state_abbrev).length);
	if ( $('#cities-for-'+state_abbrev).length > 0) {
		VTips.WM.getModalManager().pushWindow( VTips.WM.Window.makeContainerAWindow('cities-for-' + state_abbrev) );
	} else {
		VTips.WM.getModalManager().pushWindow( VTips.WM.Window.createWindowWithContent('temp-city-selection', 300, 100, createVTipsModalBox( i18n.translate('general', 'loading'), 'Loading cities...', true)) );

		var t = this;
		jQuery.ajax({
			url:'/locations/locations.json?state=' + state_abbrev,
			dataType:'json',
			success:function(data) {
				if (data.success) {
					console.log('lm.openCitySelectionForStatePane: SUCCESS: ' + state_abbrev);
					$('body').append(data.html);

					setTimeout(function() {
						VTips.WM.getModalManager().popWindow();
						VTips.WM.getModalManager().pushWindow( VTips.WM.Window.makeContainerAWindow('cities-for-' + state_abbrev) );
						}, 100);

					//VTips.WM.getModalManager().pushWindow( VTips.WM.Window.createWindowWithContent('cities-for-' + state_abbrev, 800, 500, data.html) );
					//alert(data.html.length);
				} else { // Error
					console.log('lm.openCitySelectionForStatePane: ERROR');
				}
			}
		});
	}
}

LocationManager.prototype.openSelectionPane = function() {
	console.log('lm.openSelectionPane');
	var state = this.getState();
	var country = this.getCountry();
	if (country && state) {
		console.log('lm.openSelectionPane: country: ' + country + ' && state: ' + state);
		var modal = VTips.WM.getModalManager();
		//console.log(this);
		modal.pushWindows([
				  VTips.WM.Window.makeContainerAWindow('country-selection'),
				  VTips.WM.Window.makeContainerAWindow('states-for-'+country)],
				  { addOverlay : true, allowClickOutside : true }
				  );
		this.openCitySelectionForStatePane(state);
	} else {
		console.log('lm.openSelectionPane: NOT country && state');
		VTips.WM.getModalManager().pushWindow(VTips.WM.Window.makeContainerAWindow('country-selection'));
	}
}

LocationManager.prototype.setLocation = function(location_id, country, state, city_key, city_name) {
	console.log('setLocation: ' + location_id, country, state, city_key, city_name);
	this.setCountry(country);
	this.setState(state);
	this.setCityKey(city_key);
	this.setCityName(city_name);
	this.setLocationId(location_id);
}

LocationManager.prototype.changeDestination = function(location_id, country, state, city_key, city_name, category) {
	console.log('lm.changeDestination');
	this.usingNearbyRegion = false;
	VTips.WM.getModalManager().close();
	this.setCountry(country);
	this.setState(state);
	this.setCityKey(city_key);
	this.setCityName(city_name);
	this.setLocationId(location_id);
	if (typeof(category) == 'string' || typeof(category) == 'integer') this.setCategory(category);
	else {
		this.setCategory('mdr');
		restoreFilters();
	}
	this.setCurrentView('');
	$(this).trigger('onChangeDestination', {
			location:this,
			loadingLabel:this.getCityName()
			});
}
LocationManager.prototype.changeCategory = function(category, category_name) {
	this.setCategory(category);
	$(this).trigger('onChangeDestination', {
			location:this,
			loadingLabel:category_name
			});
}
LocationManager.prototype.changeCurrentView = function(view, view_name) {
	this.setCurrentView(view);
	$(this).trigger('onChangeDestination', {
			location:this,
			loadingLabel:view_name
			});
}
/* Not used
LocationManager.prototype.calculateMilesAway = function() {
	$('#miles_away').html('Calculate distance from ' + lm.getCityName());
}
*/
LocationManager.prototype.getBaseLink = function() {
	var base_link = '/' + this.getCountry() + '/' + this.getState() + '/' + this.getCityKey() + '/';
	var category = this.getCategory();
	if (category.length > 0) base_link += category + '/';
	return base_link;
}

/**
 * 10. Banner Pool Management Class
 **/
var banner_response = {
	startIndex : 0,
	bannerCount : 3,
	banners : [
		{image:'', link:''}
		]
}
var BannerPool = function(container_id, pool_id, number_per_load) {
	this.containerId = container_id;
	this.poolId = pool_id;
	this.numPerGroup = number_per_load;
	this.reset();
	this.timer = null;
}
BannerPool.prototype.reset = function() {
	this.sendStats = true;
	this.availableDownloads = 0;
	this.banners = [];
	this.bannerIndex = -1;
	this.clearContainer();
}
BannerPool.prototype.startTimer = function() {
	var t = this;
	if (this.timer) clearTimeout(this.timer);
	var seconds = window.location.hash.substring(0, 8) == '#seconds' ? parseInt(window.location.hash.substring(8)) : 10;
	this.timer = setInterval(function() { t.displayNext(); }, seconds*1000);
	this.displayNext();
}
BannerPool.prototype.displayNext = function(source) {
	this.clearContainer();
	var $container = jQuery('#' + this.containerId);

	for (var i=0, j=this.numPerGroup; i < j; i++) {
		if (i >= this.banners.length) {
			if (this.timer) clearTimeout(this.timer);
			return;
		}

		this.bannerIndex++;
		if (this.bannerIndex > this.banners.length-1) {
			this.bannerIndex = 0;
			this.sendStats = false;
		}
		// console.log('ITERATE: ' + this.poolId + ': ' + this.bannerIndex + ') ' + this.sendStats);

		var banner = this.banners[this.bannerIndex];
		this.statBanner(banner);

		var $banner = jQuery('<div />').addClass('banner')
			.append(
				$('<a />').attr({
					href: banner.link,
					onclick: 'doit({&quot;event&quot;:&quot;Click Banner Link&quot;,&quot;bannerPool&quot;:&quot;' + this.poolId + '&quot;,&quot;url&quot;:&quot;' + encodeURI(banner.link) + '&quot;});',
					target: '_blank'
				})
					.append($('<img />').attr({src: banner.image, border:0}))
			);
		$container.append($banner);
	}
}

BannerPool.prototype.statBanner = function(banner) {
	var stat = typeof(banner.stat) == 'undefined' ? true : banner.stat;
	var url = '/banners/?country=' + lm.getCountry() + '&state=' + lm.getState() + '&city=' + lm.getCityKey() + '&position=' + this.poolId + '&startindex=' + (this.bannerIndex+1) + '&action=view&b=' + banner.id;
	if (this.sendStats && stat) jQuery.get(url);
}

BannerPool.prototype.add = function(banner) {
	this.banners[this.banners.length] = banner;
}

BannerPool.prototype.clearContainer = function() {
	var $container = jQuery('#' + this.containerId);
	if ($container.length > 0) $container.html('');
}

/**
 * 11. Instantiate LocationManager (lm) and VTips.RackBuilder (rb)
 **/
var lm = LocationManager.sharedInstance();
var rb = new VTips.RackBuilder();
//rb.setLocationManager(lm);

/**
 * 12. Bind onChangeDestination event to LocationManager (lm)
 **/
$(lm).bind('onChangeDestination', function(ev, data) {

	var brochure_link = data.location.getBaseLink() + '?ajax=1';
	var current_view = data.location.getCurrentView();
	if (current_view.length > 0) brochure_link += '&overrideview=' + current_view;

	VTips.WM.getModalManager().pushWindow( VTips.WM.Window.createWindowWithContent('loading-brochure', null, null, i18n.translate('general', 'loading') + '<br /><span style="font-size:2em;">' + data.loadingLabel + '</span>') );

	loadBrochureData(brochure_link);

});

/**
 * 13. Hot Deals functions
 **/
var fnCloseHotDealsCallback = function() {};

function closeHotDeals() {
	if (typeof(fnCloseHotDealsCallback) == 'function') fnCloseHotDealsCallback(); else alert('not function');
	VTips.WM.getModalManager().close()
}

function openHotDeals(bid,fnCloseHotDeals) {

	if (typeof(fnCloseHotDeals) != 'function') fnCloseHotDeals = function() {};
	fnCloseHotDealsCallback = fnCloseHotDeals;

	var url = '/hotdeals/index.json?';
	url += (typeof(bid) == 'undefined') ? 'l='+regionId : 'b='+bid;

	var hot_deals_content = '<div id="hot-deals-close" align="right"><a href="#" onclick="closeHotDeals();return false;" class="btn btn-backtorack">' + i18n.translate('general', 'backTo') + '<i class="btn-backtorack-arrow"></i><i class="btn-backtorack-grid"></i></a></div>';
	hot_deals_content += '<div align="center" class="title"><img src="/assets/vtips/img/hotdeals/txt_hotdeals.png" width="539" height="70" border="0" /></div>';
	hot_deals_content += '<div id="hot-deals-body" class="body">' + i18n.translate('general', 'loading') + '</div>';
	var wndw = VTips.WM.Window.createWindowWithContent('hot-deals-popup', null, null, hot_deals_content);
	VTips.WM.getModalManager().pushWindow( wndw, {allowClickOutside:true} );

	var overlayObj = VTips.WM.getModalManager().getOverlayObj();

	var width = jQuery(window).width()-180;
	var height = jQuery(window).width()-120;
	var top = 120;
	overlayObj.css('width', width);
	overlayObj.css('height', height);
	overlayObj.css('top', top);

	jQuery.ajax({
		url:url,
		dataType:'json',
		success:function(data) {
			if (data.success) {
				$('#hot-deals-body').html(data.html);
				doit({"event":"View Hot Deals","hotDealFilter":(typeof(bid) == 'undefined') ? 'Region' : 'Brochure'});
			}
		}
	});
}

/**
 * @param object|string
 *
 * Can pass as part of link, e.g. <a href="/path/to/popup" onclick="openDealView(this);return false;">Open</a>
 * or
 * URL e.g. openDealView('/path/to/popup')
 */
function openDealView(a) {
	var $a = null, dealUrl = '', $body = $('body');

	if (typeof(a) == 'string') {
		dealUrl = a;
	} else if (typeof(a) == 'object') {
		$a = $(a);
		dealUrl = $a.attr('href');
	} else {
		return;
	}

	var restoreBtnHtml = null;
	var $loading = null;

	if (null !== $a && $a.text().trim() == $a.html().trim()) {
		restoreBtnHtml = $a.html();
		$a.text('Loading...');
		$loading = createLoadingImage();
		$loading.css({
			position: 'absolute',
			left: $a.offset().left - 16,
			top: ($a.offset().top + ($a.outerHeight(true)/2)) - (16/2)
		});
		$body.append($loading);
	}

	$overlay = $('<div />')
		.css({
			backgroundColor: '#000',
			opacity: .3,
			position: 'fixed',
			top: 0, right: 0, bottom: 0, left: 0,
			visibility: 'hidden'
		})
		.appendTo($body);

	$dealPopup = $('<div/>')
		.attr('id', 'deal-popup')
		.css({
			margin: '0 auto',
			maxWidth: '100%',
			position: 'absolute',
			top: $(window).scrollTop() + 20,
			visibility: 'hidden',
			width: 856
		})
		.appendTo($body);

	$iframe = $('<iframe />')
		.attr('src', dealUrl)
		.css({
			border: 0,
			// position: 'absolute',
			// visibility: 'hidden',
			width: '100%'
		})
		.appendTo($dealPopup)
		.load(function() {
			$dealPopup.css('visibility', 'visible');
			$overlay.css('visibility', 'visible');
			setTimeout(function() {
				$iframe.get(0).style.height = $iframe.get(0).contentWindow.document.body.scrollHeight + 'px';
				if (null !== restoreBtnHtml) {
					$loading.remove();
					$a.html(restoreBtnHtml);
				}
			}, 50);
		});

	$(window).resize(dealWindowSize).scroll(dealWindowSize);

	$overlay.click(function() {
		$(window).unbind('resize', dealWindowSize).unbind('scroll', dealWindowSize);
		closeDeal();
	});

	var closeOffset = 26;
	var closeSize = 16;
	var $close = $('<a/>')
		.attr('href', '#')
		.click(function(ev) {
			ev.preventDefault();
			closeDeal();
		})
		.appendTo($dealPopup)
		.append($('<img/>').attr('src', '/assets/vtips/img/window/i_x.png').css({
			height: closeSize,
			// left: $iframe.offset().left + $iframe.outerWidth(true) - closeSize - closeOffset,
			right: closeOffset,
			position: 'absolute',
			// top: $iframe.offset().top + closeOffset,
			top: closeOffset,
			width: closeSize,
			zOffset: 2
		}));

	dealWindowSize();

	function dealWindowSize() {
		// var defaultWidth = 856;
		// var width = defaultWidth > $(window).width() ? $(window).width() : defaultWidth;
		// var left = ($(window).width()/2) - (width/2);
		var left = ($(window).width()/2) - ($dealPopup.width()/2);
		// var top = jQuery(window).scrollTop(); // jQuery('#header').offset().top;
		// var height = $(window).height() - top + $(window).scrollTop();
		// console.log('height: ' + height);
		var css = {
			left: left,
			// top: $(window).scrollTop() + 20,
			// width: width,
			// height: height
		};
		$dealPopup.css(css);
		// $iframe.css(css);
	}
	function closeDeal() {
		$dealPopup.remove();
		$overlay.remove();
		$close.remove();
	}
}

function filterDeals(a) {
	var $a = $(a);
	var $cols = $($a.attr('data-deal-sel'));
	var $noDeals = $('#no-deals');
	var catId = parseInt($a.attr('data-filtercategoryid'));
	var numVisible = 0;
	$cols.each(function() {
		var catIds = $(this).attr('data-categoryids').length > 0 ? $(this).attr('data-categoryids').split(',').map(function(val) { return parseInt(val); }) : [];
		if (isNaN(catId) /* all */ || catIds.indexOf(catId) >= 0) {
			numVisible++;
			$(this).show();
		} else $(this).hide();
	});
	if (numVisible == 0) $noDeals.show();
	else $noDeals.hide();
}

/**
 * 14. loadBrochureData function
 **/
function loadBrochureData(brochure_link) {
	jQuery.get(brochure_link, function(data) {
		VTips.WM.getModalManager().close();
		$('#ph_main').html(data);
	});
}
/**
 * 15. initMapOnPoint function
 **/
async function initMapOnPoint(map_id, lat, lng) {
	const position = {lat: lat, lng: lng};
  const { Map } = await google.maps.importLibrary("maps");
  const { Marker } = await google.maps.importLibrary("marker");
  const myOptions = {
    zoom: 12,
    center: position,
    mapTypeId: 'roadmap'
  };
  const map = new Map(document.getElementById(map_id), myOptions);
  const marker = new Marker({
    position: {lat: lat, lng: lng},
    map: map
  });
}

/**
 * 16. Panel class
 **/
function Panel(id) {
	this.id = id;
	this.visible = true;
	this.isWidthFixed = false;
	this.isHeightFixed = false;
	}
Panel.prototype.getId = function() { return this.id; }
Panel.prototype.getObj = function() { return jQuery('#' + this.getId()); }
Panel.prototype.isVisible = function() { return this.visible; }
Panel.prototype.show = function() {
	if (!this.isVisible()) {
		this.getObj().show('fast');
	}
	this.visible = true;

}
Panel.prototype.hide = function() {
	if (this.isVisible()) {
		this.getObj().hide();
	}
	this.visible = false;
}

/**
 * 17. DestinationView class
 **/
function DestinationView() {
	this.panels = {};
}
DestinationView.prototype.addPanel = function(name) {
	this.panels[name] = new Panel(name);
	return this.panels[name];
}
DestinationView.prototype.getPanel = function(name) {
	return this.panels[name];
}
DestinationView.prototype.hidePanel = function(name) {
	this.getPanel(name).hide();
}
DestinationView.prototype.showPanel = function(name) {
	this.getPanel(name).show();
}
var dview = new DestinationView();
dview.addPanel('left-bar');
dview.addPanel('resource-bar');
dview.addPanel('header-bar');
dview.addPanel('ph_main');

/**
 * 18. Rack repositioning timer
 **/
var reposition_rack_timer = null;
$(document).ready(function(){
	// Don't reposition rack for mobile
	if (isMobile) return;

	$(window).resize(function() {
		if (reposition_rack_timer) clearTimeout(reposition_rack_timer);
		reposition_rack_timer = setTimeout(function() { clearTimeout(reposition_rack_timer); rb.repositionRack(true); }, 100);
	});
	$(window).scroll(function() {
		if (reposition_rack_timer) clearTimeout(reposition_rack_timer);
		reposition_rack_timer = setTimeout(function() { clearTimeout(reposition_rack_timer); rb.repositionRack(true); }, 100);
	});

});

/**
 * 19. Kiosk Timer
 **/
function startKioskTimer(timeLeft, displayTimer) {

	var timer = null;

	var $sessionClock = $('<div />').attr('id', 'session-clock').css({
		backgroundColor: 'rgba(0,0,0,.8)',
		position: 'fixed',
		top: 0,
		left:'10px',
		zIndex:100,
		textAlign: 'center',
		padding: '5px',
		color: '#fff',
		/*width:'160px',*/
	}).hide().appendTo($('body'));

	//var $clockDescription = $('<div />').css({fontSize:'18px',color:'#ccc'}).text('Resets in...').appendTo($sessionClock);
	var $clockTime = $('<div />').css({fontSize:'11px'}).appendTo($sessionClock);
	if (displayTimer) $sessionClock.show();

	function timeTick() {
		timeLeft--;
		if (timeLeft <= 0) {
			clearInterval(timer);
			$clockTime.text('Restarting...')
			window.location.href='/?resetkiosk=true';
			return;
		}
		showTime();
	}
	function showTime() {

		timeLeftLabel = '';
		secondsLeft = timeLeft;
		var minutes = Math.floor(secondsLeft / 60);
		if (minutes > 0) {
			secondsLeft -= minutes*60;
			timeLeftLabel = minutes + ' minute(s) ';
		}
		sSeconds = secondsLeft.toString();
		if (sSeconds.length == 1) sSeconds = '0'+sSeconds;
		timeLeftLabel += sSeconds + ' second(s)';

		$clockTime.html('Kiosk will reset in... ' + timeLeftLabel);
	}

	showTime();
	timer = setInterval(timeTick, 1000);

	var $urlOverlay = null;
	var $urlWindow = null;
	var $urlClose = null;

	function closeKioskUrl() {
		if ($urlOverlay) $urlOverlay.remove();
		if ($urlWindow) $urlWindow.remove();
		if ($urlClose) $urlClose.remove();
	}
	function activateLinks($base) {
		$base.find('body');
		$links = $base.find('a').not('.kiosk-link');

		$links.each(function(ix) {
			var $a = $(this).addClass('kiosk-link');

			var href = $a.attr('href');
			var hrefTarget = $a.attr('target');
			if (href) {
				var hrefPos = href.indexOf('://');
				if (hrefTarget) $a.attr('target', '');

				if (hrefPos >= 0) {
					$a.click(function(ev) {
						ev.preventDefault();
						openKioskUrl('/go/kiosk.html?url=' + encodeURIComponent(href) + '&source=' + encodeURIComponent(window.location.href));
					});
				}
			}
		});
	}
	function openKioskUrl(url) {
		//url = '/go/kiosktest.html';
		closeKioskUrl();

		$urlOverlay = $('<div />').addClass('modal-overlay');
		$urlWindow = $('<div />').addClass('kiosk-browser-window');
		$iFrame = $('<iframe />').addClass('kiosk-browser').appendTo($urlWindow);

		$urlClose = $('<a/>')
			.addClass('kiosk-browser-close')
			.attr('href', '#')
			.text('CLOSE')
			.click(function() { closeKioskUrl(); });

		$iFrame.load(function() {
			activateLinks($(this).contents());
		});

		$('body').append($urlOverlay, $urlWindow, $urlClose);

		$iFrame.attr('src', url);
	}

	activateLinks($('body'));

}


/**
 * 20. Touch punch for enabling touch
 **/
/*
 * jQuery UI Touch Punch 0.2.2
 *
 * Copyright 2011, Dave Furfero
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 * Depends:
 *  jquery.ui.widget.js
 *  jquery.ui.mouse.js
 */
(function(b){b.support.touch="ontouchend" in document;if(!b.support.touch){return;}var c=b.ui.mouse.prototype,e=c._mouseInit,a;function d(g,h){if(g.originalEvent.touches.length>1){return;}g.preventDefault();var i=g.originalEvent.changedTouches[0],f=document.createEvent("MouseEvents");f.initMouseEvent(h,true,true,window,1,i.screenX,i.screenY,i.clientX,i.clientY,false,false,false,false,0,null);g.target.dispatchEvent(f);}c._touchStart=function(g){var f=this;if(a||!f._mouseCapture(g.originalEvent.changedTouches[0])){return;}a=true;f._touchMoved=false;d(g,"mouseover");d(g,"mousemove");d(g,"mousedown");};c._touchMove=function(f){if(!a){return;}this._touchMoved=true;d(f,"mousemove");};c._touchEnd=function(f){if(!a){return;}d(f,"mouseup");d(f,"mouseout");if(!this._touchMoved){d(f,"click");}a=false;};c._mouseInit=function(){var f=this;f.element.bind("touchstart",b.proxy(f,"_touchStart")).bind("touchmove",b.proxy(f,"_touchMove")).bind("touchend",b.proxy(f,"_touchEnd"));e.call(f);};})(jQuery);
// copy changes to mobile/site.js
/**
 * 21. Category Filters
 */
var waitingForFilters = 0;
var filterOn = false;
var filterArchive = {};
function showFilter(key, name) {
	if (!filterOn) {
		waitingForFilters = 6;
		filterId = 'filter-' + key;
		//$('.filter:not(#'+filterId+')').hide('fast', function() {
		$('.filter').hide('fast', function() {
			waitingForFilters --;
			if (waitingForFilters == 0) {
				$('#filter-remove').show('fast');
				$('#filter-'+key).show('fast')
				filterOn = true;
			}
		});
		setTimeout(function() { lm.changeCategory(key, name); }, 150);
	}
}
function restoreFilters() {
	waitingForFilters = 6;
	$('.filter').show('fast', function() {
		waitingForFilters--;
		if (waitingForFilters == 0) {
			$('#filter-remove').hide()
		}
	});
	filterOn = false;
}
function removeFilters() {
	restoreFilters();
	setTimeout(function() { lm.changeCategory('mdr', 'Main Rack'); }, 50);
}

function setCategoryState(key, state) { // 0 disabled; 1 enabled; 2 active
	return;
	var obj = $('#filter-'+key);

	if (obj.length > 0) {

		obj.removeClass('filter-'+key);
		obj.removeClass('filter-'+key+'-active');
		obj.removeClass('filter-'+key+'-disabled');

		if (state == 0) {
			if (!filterArchive[key]) filterArchive[key] = obj.html();
			obj.html('<img src="/assets/vtips/img/tpl/btns/button.png" width="150" height="26" border="0" />');
			obj.addClass('filter-'+key+'-disabled');
		} else {
			if (filterArchive[key]) obj.html(filterArchive[key]);
			filterArchive[key] = null;
			if (state == 2) {
				obj.addClass('filter-'+key+'-active');

			} else {
				obj.addClass('filter-'+key);

			}

			if (state == 1) obj.removeClass('filter-'+key+'-active');
			else if (state == 2 && !obj.hasClass('filter-'+key+'-active')) obj.addClass('filter-'+key+'-active');
		}

	}

}
/**
 * 22. Search
 */
var searchTimer = null;
var lastKeyword = '';
function updateSearch(obj) {

	var val = obj.value;
	var $results = $('#popup-search-results');
	if (val == lastKeyword) return;

	if ($results.length == 0) {
		$results = $('<div />').attr('id', 'popup-search-results').addClass('body-shadow').prependTo($('#ph_main'));
	}

	var $close = $('<a />').attr('href', '#').addClass('results-close').click(function(ev) {
		obj.value = '';
		$results.remove();
	}).append(  $('<img />').attr('src', '/assets/vtips/img/window/b_x.png')  );

	$rackSlider = $('.rack-slider');
	$results.css({
		// opacity:.95,
		// left: $rackSlider.offset().left,
		// top: $rackSlider.offset().top,
		// width: $rackSlider.outerWidth(),
		// height: $rackSlider.outerHeight()
	});

	if (val.length == 0) {
		$results.hide();
	} else {
		$results.empty().show();
		if (val.length < 3) {
			$results.html('Enter 3 or more characters to search...');
			$close.appendTo($results);
		} else {
			if (searchTimer) clearTimeout(searchTimer);
			$results.html('Typing...');
			searchTimer = setTimeout(function() {
				lastKeyword = val;
				$results.html('Loading results...');
				var locId = LocationManager.sharedInstance().getLocationId();
				var searchUrl = '/search/keyword.json?returnpath=' + encodeURIComponent(window.location.href);
				if (typeof(locId) == 'string' && locId.length > 0 || locId > 0) searchUrl += '&locid=' + locId;
				$.ajax(searchUrl, {
					data:{q:val},
					success: function(data) {

						var listings = data.listings;
						var locations = data.locations;
						$results.empty();
						$close.appendTo($results);
						if (locations.length > 0) {
							$results.append($('<h3 />').text('Locations'));
							for(i=0; i < locations.length; i++) {
								var $a = $('<a />').attr('href', locations[i].link).text(locations[i].label);
								$results.append( $('<div />').append($a) );
							}
						}
						if (locations.length > 0 && listings.length > 0) $results.append('<hr />');
						if (listings.length > 0) {
							$results.append($('<h3 />').text('Brochures'));
							$listings = $('<div />').addClass('listing-results'); // css('width',9000);
							$results.append($listings);
							for(i=0; i < listings.length; i++) {
								var $listing = $('<div />').addClass('search-brochure').css({margin:'0 5px 5px',width:100});
								var $a = $('<a />').attr('href', listings[i].link);
								var $img = $('<img />').attr({src:listings[i].image,width:100});
								$a.append($img);
								$listing.append($a);
								// $listing.append( $('<span />').text(listings[i].label) );
								$listings.append($listing);
							}
						} else {
							$results.append( $('<span />').text('There were not any results that matched your search') );
						}
					},
					error : function(jqXHR, textStatus, errorThrown) {
						alert('Unable to load search results at this time.  Please try again in a little bit.');
					}
				});
			}, 500);
		}
	}
}

$(function() {
	var timer0, popupTimer;
	var lastValue = {};
	var lastResults = {};
	// var searchLocationId;
	var searchLocationName = '';
	var $searchPopup;
	/**
	 * Whether a result was select from the search results
	 */
	var didSelectResult = false;

	function delayedChangeQuery($field, fn) {
		// console.log('delayedChangeQuery: ' + $field.attr('id'));
		$field.keyup(function(ev) {
			if (typeof(lastValue[$field.attr('id')]) != 'undefined' && $field.val() == lastValue[$field.attr('id')]) return;
			if (typeof(lastResults[$field.attr('id')]) != 'undefined') delete lastResults[$field.attr('id')];

			if (timer0) clearTimeout(timer0);
			lastValue[$field.attr('id')] = $field.val();
			if ($field.val().length == 0) return;
			timer0 = setTimeout(function() {
				fn.call(null, $field);
			}, 250);
		});
	}

	var popupTimerInterval = 250;
	function removePopup(immediately) {
		// console.log('removePopup: immediately: ' + (immediately ? 'true' : 'false'));
		function wrapUp() {
			// console.log('wrapUp');
			if ($searchPopup) {
				$searchPopup.remove();
				$searchPopup = null;
			}
		}
		if (popupTimer) clearTimeout(popupTimer);

		if (immediately) wrapUp();
		else {
			popupTimer = setTimeout(function () {
				wrapUp();
			}, popupTimerInterval);
		}
	}

	function handleFocus(fnDisplayResults) {
		// console.log('handleFocus');
		didSelectResult = false;
		return function(ev) {
			if (popupTimer) clearTimeout(popupTimer);
			var id = $(this).attr('id');
			if (typeof(lastResults[id]) != 'undefined') {
				fnDisplayResults.call(null, $(this), lastResults[id]);
			}
		}
	}

	function handleBlur(ev) {
		// console.log('handleBlur');
		removePopup();
	}
	function handleLocationBlur(ev) {
		// console.log('handleLocationBlur');
		var $obj = $(this);
		setTimeout(function () {
			// console.log('handleLocationBlur.timeout');
			if (!didSelectResult) {
				var id = $obj.attr('id');
				if (typeof(lastResults[id]) == 'undefined' || lastResults[id].length == 0) return;
				$obj.val(lastResults[id][0].name);
				// searchLocationId = lastResults[id][0].locationId;
				$('#l').val(lastResults[id][0].locationId);
				$('#ct').val(lastResults[id][0].cityId);
			}
		}, popupTimerInterval/2); // must occur before removePopup timer is called to avoid conflicts
		removePopup();
	}

	function resultPopup($field) {
		// console.log('resultPopup');
		if (!$searchPopup) {
			$searchPopup = $('<div />').addClass('search-dropdown').appendTo($('body'));
		}
		return $searchPopup.empty().css({
			top: $field.offset().top + $field.outerHeight(true) + 2,
			left: $field.offset().left,
			width: $field.outerWidth(),
		});
	}

	function displayKeywordResults($keyword, results) {
		// console.log('displayKeywordResults');
		if (results.length == 0) {
			resultPopup($keyword).text('No results matched your search');
			$('#search-results').hide();
			return;
		}
		removePopup(true);
		var $results = $('#search-results').empty();
		for(var i=0; i < results.length; i++) {

			var $result = $('<div />').addClass('result left');
			var $images = $('<div />').addClass('images');
			if (results[i].images.length > 0) {
				var $image = $('<img />').attr({src: results[i].images[0]})
				$images.append($image);
			}
			var $title = $('<div />').addClass('title');
			var $link = $('<a />').attr('href', results[i].link).text(results[i].name);
			var $desc = $('<div />').text(results[i].description);

			$link.click(function(ev) {
				// ev.preventDefault();
				// removePopup(true);
			});

			$title.append($link);
			$result.append($images, $title, $desc);

			$results.append($result);
		}
		$results.show();
	}

	function fetchKeywordResults($keyword) {
		jQuery.ajax({
			url: i18n.getUrl('/external/listings/search.json', 'q=' + encodeURI($keyword.val())),
			dataType: 'json',
			error: function(data) {},
			success: function(data) {
				if (data.success) {
					if (data.results.length > 0) lastResults[$keyword.attr('id')] = data.results;
					displayKeywordResults($keyword, data.results);
				} else {
					resultPopup($keyword).text('An error occured');
				}
			}
		});
	}

	function displayLocationResults($location, results) {
		// console.log('displayLocationResults = true');
		var $popup = resultPopup($location);
		if (results.length == 0) $popup.text('No results matched your search');
		else {
			var $list = $('<ul />');
			for (var i = 0; i < results.length; i++) {
				var $li = $('<li />');
				var $link = $('<a />')
					.attr({'href': '#', 'data-location': results[i].locationId, 'data-city': results[i].cityId, 'data-label': results[i].name})
					.text(results[i].name)
					.click(function (ev) {
						ev.preventDefault();
						didSelectResult = true;
						removePopup(true);
						$('#l').val($(this).attr('data-location'));
						$('#ct').val($(this).attr('data-city'));
						$location.val($(this).attr('data-label'));
						$location.parents('form').submit();
					});
				$li.append($link);
				$list.append($li);
			}
			$popup.append($list);
		}
	}
	function fetchLocationResults($location) {
		// console.log('fetchLocationResults');
		jQuery.ajax({
			url: i18n.getUrl('/external/locations/searchcities.json', 'q=' + encodeURI($location.val())),
			dataType: 'json',
			error: function(data) {},
			success: function(data) {
				if (data.success) {
					lastResults[$location.attr('id')] = data.results;
					displayLocationResults($location, data.results);
				} else {
					resultPopup($keyword).text('An error occured');
				}
			}
		});
	}

	$keyword = $('#keyword-query').blur(handleBlur).focus(handleFocus(displayKeywordResults));
	$location = $('#location-query').blur(handleLocationBlur).focus(handleFocus(displayLocationResults));

	// delayedChangeQuery($keyword, fetchKeywordResults);
	delayedChangeQuery($location, fetchLocationResults);
});

/**
 * 23. Stats
 **/
function doit(obj) {
	if (typeof(dataLayer) != 'undefined') dataLayer.push(obj); // Google
	if (typeof(mixpanel) != 'undefined') {
		var mpd = {};
		var evname = obj.event;
		for(var i in dataLayer) if (i != 'event') mpd[i] = dataLayer[i];
		mixpanel.track(evname, mpd);
	}
}
/**
 * 24. Utility
 */
function createLoadingImage() {
	return $('<img />').attr({src:'/assets/vtips/img/ajax-loader-circle.gif', width:16,height:16,border:0});
}
function sharedLoadingImage() {
	if (!$loadingImage) $loadingImage = createLoadingImage();
	return $loadingImage;
}
